<template>
 <div>
    <div v-if="uid === '8650fc2a-b684-496d-92fc-85c73eced49a'">
      <nav-bar />
      <h1 class="m-2 kne-title">DEV AREA</h1>
      <div class="mx-5">
        <regular-input class="my-2" :value="updateMessage.title" :placeholder="`${$t('Dev.title')}*`" @input="isConfirmed = false; setFeedbackMessage(''); updateMessage.title = $event"/>
        <regular-input class="my-2" :value="updateMessage.devNote" :placeholder="`${$t('Dev.dev_note')}*`" @input="isConfirmed = false; setFeedbackMessage(''); updateMessage.devNote = $event"/>
        <regular-input class="my-2" :value="updateMessage.description.en" :placeholder="`${$t('Dev.description')} EN*`" @input="isConfirmed = false; setFeedbackMessage(''); updateMessage.description.en = $event"/>
        <regular-input class="my-2" :value="updateMessage.description.fr" :placeholder="`${$t('Dev.description')} FR*`" @input="isConfirmed = false; setFeedbackMessage(''); updateMessage.description.fr = $event"/>

        <p>{{$t('Dev.update_target')}}</p>
        <div class="toggleSwitch" v-if="optionList">
          <toggle-switch
            class="border"
            :optionList="optionList"
            :multiple="false"
            @emitSelectedOption="updateOptionSelect"
          />
        </div>

        <div class="mt-2 mx-0">
          <p id="feedbackMsg">{{feedbackMessage}}</p>
          <button class="btn btn-kne-orange" @click="pushNewUpdate(updateMessage)">{{pushNewUpdateBtnMsg}}</button> 
        </div>
      </div>
    </div>

    <div v-else>
      <nav-bar />
      <h1 class="kne-title">DEV AREA - NOT MADE FOR PROD</h1>
    </div>
  </div>
</template>

<script>
import { db } from '../../firebase'
import regularInput from '../module/basic-components/regularInput.vue'
import regularInputNumber from '../module/basic-components/regularInputNumber.vue'
import NavBar from '../module/interface-components/NavBar.vue'
import ToggleSwitch from '../module/special-components/Other-components/ToggleSwitch.vue'
export default {
  name: 'Dev',
  components: {
    NavBar,
    ToggleSwitch,
    regularInputNumber,
    regularInput
  },
  created () {
    if (this.uid !== '8650fc2a-b684-496d-92fc-85c73eced49a') this.$router.push('OrderCurrent')
  },

  data () {
    return {
      optionList: {
        transporter: {
          id: 1,
          label: this.$t('Dev.transporter'),
          value: 'transporter',
          selected: false,
          selectedBgColor: 'rgb(255, 178, 84, 30)'
        },
        dealer: {
          id: 2,
          label: this.$t('Dev.dealer'),
          value: 'dealer',
          selected: false,
          selectedBgColor: 'rgb(255, 178, 84, 30)'
        }
      },
      updateMessage: {
        description: {
          en: '',
          fr: ''
        },
        devNote: '',
        title: ''
      },

      feedbackMessage: '',
      selectedOption: '',
      isConfirmed: false
    }
  },

  methods: {
    pushNewUpdate (updateMessage) {
       if (updateMessage.description === '' || updateMessage.devNote === '' || updateMessage.description.en === '' || updateMessage.description.fr === '') {
        this.setFeedbackMessage(this.$t('Dev.error_missing_fields'))
        return
      }

      if (this.selectedOption === '') {
        this.setFeedbackMessage(this.$t('Dev.error_select_target'))
        return
      }

      if (!this.isConfirmed) {
        this.isConfirmed = true
        this.setFeedbackMessage(this.$t('Dev.confirm_message'), 'green-text')
        return
      }

      this.firebasePush(`updates/${this.selectedOption}`, updateMessage)
      this.clearFields()
    },

    firebasePush (path, pushObject) {
      db.ref(path).push(pushObject)
    },

    setFeedbackMessage (message, className = 'red-text') {
      this.feedbackMessage = message
      document.getElementById('feedbackMsg').className = className
    },

    clearFields () {
      this.resetUpdateMessage()
      this.resetUpdateTarget()
      this.setFeedbackMessage('')
      this.isConfirmed = false
      this.selectedOption = ''
    },

    resetUpdateMessage () {
      for (const key in this.updateMessage) {
        if (Object.hasOwnProperty.call(this.updateMessage, key)) {
          this.updateMessage[key] = ''
        }
      }
    },

    resetUpdateTarget () {
      for (const key in this.optionList) {
        if (Object.hasOwnProperty.call(this.optionList, key)) {
          this.optionList[key].selected = false
        }
      }
    },

    updateOptionSelect (selectedOption) {
      this.selectedOption = selectedOption.value
    }
  },

  computed: {
    uid () {
      return this.$store.state.user.uid
    },

    pushNewUpdateBtnMsg () {
      if (!this.isConfirmed) return this.$t('General.confirm')
      else return this.$t('General.send')
    }
  }
}
</script>

<style scoped>
  .toggleSwitch {
    display: flex;
    flex-direction: row;
  }
</style>
